import { BonusPayloadType } from "../../../types";
import { BonusType } from "../../constants";

export const BONUS_INITIAL_VALUES: BonusPayloadType = {
  taxes: {
    bonusType: BonusType.DISCRETIONARY,
    nonDiscretionaryType: undefined,
    reason: undefined,
  },
  paymentSettings: {
    payPeriodId: "",
    disbursementDate: "",
    deliveryMethod: "electronic",
    notes: "",
  },
};
